<div class="card" style="max-width: 19rem; margin-top: 10px;margin:0 auto;text-align: left;;background-color: #D8D8D8;border: 5px solid grey;border-radius: 25px; margin-bottom: 10px;">
    <div class="card-body">
      <h5 class="card-title" style="font-size: 17px;">{{order.getTitle()}}</h5>
      <h6 class="card-subtitle mb-2 text-muted"style="font-size: 12px;">{{order.getTime()}}</h6>
      <button class="card-link" (click) = putBackInList()>remove</button>
    </div>
  </div>
